// extracted by mini-css-extract-plugin
export var fullGrid = "_3l-3";
export var pdpPreviewContainer = "_3l-1";
export var previewContainer = "_3l-0";
export var togglePreviewContainer = "_3l-2";